import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useConstants } from "../hooks/UseConstants";
import PageHero from "./motion/PageHero";
import { resolveAdminPageMeta } from "../helper/resolveAdminPageMeta";

/**
 * Blue animated page title banner — same pattern as teacher Courses/Paths pages.
 * Skips dashboard (uses welcome banner instead).
 */
export default function AdminPageHero({ title, subtitle, icon, actions, className = "" }) {
    const { pathname } = useLocation();
    const { language } = useConstants();
    const isAr = language === "ar";

    const meta = useMemo(() => resolveAdminPageMeta(pathname, isAr), [pathname, isAr]);

    if (/^\/dashboard\/?$/.test(pathname)) {
        return null;
    }

    const Icon = meta.Icon;
    const resolvedIcon = icon ?? (Icon ? <Icon /> : null);

    return (
        <PageHero
            className={className}
            title={title ?? meta.title}
            subtitle={subtitle ?? meta.subtitle}
            icon={resolvedIcon}
            actions={actions}
        />
    );
}
